import React, { memo } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { HighchartsReact } from 'investira.react.charts';
import { AVALIACAO_SESSOES } from '../../../enums';

const AvaliacoesOutputPerfomance = memo(props => {
  const { sessoes } = props;

  const xSessoes = sessoes && Array.isArray(sessoes) && sessoes.length > 0
    ? sessoes
    : Object.values(AVALIACAO_SESSOES).map(xCat => {
        const xNota = Math.random() * 3;
        const xNotaPeso = Math.random() * 3;
        return { ...xCat, nota: xNota, nota_peso: xNotaPeso };
      });

  const xOptions = {
    chart: {
      polar: true,
      type: 'line'
    },

    title: {
      text: ''
      //text: 'Performance por sessão'
      //x: -80
    },

    pane: {
      //size: '80%'
    },

    xAxis: {
      categories: [...xSessoes.map(cat => cat.label)],
      tickmarkPlacement: 'on',
      lineWidth: 0
    },

    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0,
      tickInterval: 1
    },

    tooltip: {
      shared: true,
      pointFormat:
        '<span style="color:{series.color}">● </span>{series.name}: <b>{point.y}</b><br/>'
    },

    // legend: {
    //   align: 'right',
    //   verticalAlign: 'middle',
    //   layout: 'vertical'
    // },

    series: [
      {
        name: 'Avaliação da entidade',
        data: [...xSessoes.map(cat => cat.nota_peso)],
        pointPlacement: 'on'
      },
      {
        name: 'Avaliação do gestor',
        data: [...xSessoes.map(cat => cat.nota)],
        pointPlacement: 'on'
      }
    ],

    responsive: {
      rules: [
        {
          condition: {
            //maxWidth: 500
          },
          chartOptions: {
            title: {
              x: 0
            },
            legend: {
              align: 'center',
              verticalAlign: 'bottom',
              layout: 'horizontal'
            },
            pane: {
              size: '80%'
            }
          }
        }
      ]
    }
  };

  return (
    <Stack flexGrow="1" gap={2}>
      <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
        <Stack mb={2}>
          <Typography variant="h6" color="textPrimary" sx={{ fontWeight: 600 }}>
            Performance por sessão
          </Typography>
        </Stack>
        <Stack direction="row" gap={2}>
          <Stack>
            <HighchartsReact options={xOptions} />
          </Stack>
          <Stack>
            <Stack direction="row" flexWrap="wrap" gap={2}>
              {xSessoes
                .reduce(
                  (xColunas, xSessao, xIdx) => {
                    const xColIdx = xIdx % 1; // 2 - quantidade de colunas
                    xColunas[xColIdx].push(
                      <Stack
                        key={xSessao.id}
                        mb={2}
                        sx={{
                          borderLeft: '8px solid',
                          borderColor:
                            xSessao.nota < 1.8
                              ? 'error.main'
                              : xSessao.nota < 2.2
                              ? 'warning.main'
                              : xSessao.nota < 3
                              ? 'info.main'
                              : 'primary.main',
                          px: 2
                        }}>
                        <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
                          {xSessao.label}
                        </Typography>
                        <Stack direction={'row'} gap={2}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: 'text.primary'
                            }}>
                            {Math.round(Number.isInteger(xSessao.nota))
                              ? `${xSessao.nota}.0`
                              : Math.round(xSessao.nota)}
                          </Typography>
                        </Stack>
                      </Stack>
                    );
                    return xColunas;
                  },
                  [[], []]
                )
                .map((xCol, xIdx) => (
                  <Stack key={xIdx} flex={1} minWidth="130px">
                    {xCol}
                  </Stack>
                ))}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
});

export default AvaliacoesOutputPerfomance;
